import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ChannelType = "1688" | "taobao" | "weidian";

interface ChannelState {
  selectedChannel: ChannelType;
}

const initialState: ChannelState = {
  selectedChannel: "1688",
};

const channelSlice = createSlice({
  name: "channel",
  initialState,
  reducers: {
    setChannel: (state, action: PayloadAction<ChannelType>) => {
      state.selectedChannel = action.payload;
    },
  },
});

export const { setChannel } = channelSlice.actions;
export default channelSlice.reducer;
